import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { ISelectItem } from 'components/select';
import { MarketTypes } from 'api/types';
import { sortByTitle } from 'lib/utils';

export type IBuildingListByStreet = {
  house: string;
  id: number;
  coordinates?: { latitude: number; longitude: number };
}[];

export interface ISelectItemExpended extends ISelectItem {
  coordinates?: { latitude: number; longitude: number } | null;
}

export const useBuildingListByStreet = (
  params?: {
    streetName: string | number | undefined;
    cityName: string | undefined;
    marketType: MarketTypes;
  },
  isTransformForSelect?: boolean,
  fetch = true,
) => {
  const { data, error, isLoading, mutate } = useSWR(fetch ? [params] : null, () =>
    !!params
      ? fetcher
          .swr<IBuildingListByStreet>('/building/building-by-street', {
            params: params,
          })
          .then((res) => res)
      : null,
  );

  const transformData = (
    dataList: IBuildingListByStreet | undefined | null,
  ): ISelectItemExpended[] => {
    if (dataList?.length) {
      const dataTransformed = dataList?.map((item) => ({
        key: item.id,
        label: item.house,
        coordinates: item.coordinates,
      }));
      return sortByTitle(dataTransformed) as ISelectItemExpended[];
    }
    return [];
  };

  return { buildings: isTransformForSelect ? transformData(data) : data, error, isLoading, mutate };
};

export default useBuildingListByStreet;
